import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { P2PRoom } from '@/webrtc/p2p.room';

const reducer = createSlice({
  name: 'call.reducer',
  initialState: {
    activeCall: undefined as
      | {
          connection: P2PRoom;
          pip: boolean;
        }
      | undefined,
  },
  reducers: {
    actionSetCallConnection(state, action: PayloadAction<P2PRoom | undefined>) {
      state.activeCall = action.payload
        ? {
            connection: action.payload,
            pip: false,
          }
        : undefined;
    },
    actionClearCall(state) {
      state.activeCall = undefined;
    },
    actionSetPIP(state, action: PayloadAction<boolean>) {
      if (state.activeCall) {
        state.activeCall.pip = action.payload;
      }
    },
  },
});

export const { actionSetCallConnection, actionClearCall, actionSetPIP } = reducer.actions;
export default reducer.reducer;
